import React from "react"
import { classNames } from "utils/classNames"

export default ({
  item: { name, href, button },
  icon: Icon,
  handleNavItem,
  index,
  close,
}) => {
  return (
    <>
      {button !== undefined ? (
        <div className="flex items-center justify-start w-full gap-2 p-2">
          <Icon color="#111827" className="w-5 h-5" />
          <button
            onClick={() => {
              handleNavItem(href, button)
              close()
            }}
            className={classNames(
              "text-gray-900 uppercase",
              index > 2
                ? "before:absolute before:left-[5%] before:bottom-1/4 before:w-[90%] before:h-[1px] before:bg-disabled-text-color"
                : ""
            )}
          >
            {name}
          </button>
        </div>
      ) : (
        <button
          onClick={() => {
            handleNavItem(href, button)
            close()
          }}
          className="flex items-center justify-start w-full gap-2 p-2 group hover:bg-[#2D2D2DE5] hover:backdrop-opacity-[4px] rounded-md cursor-pointer"
        >
          <Icon className="w-5 h-5 group-hover:text-white text-[#111827]" />
          <div
            className={classNames(
              "text-gray-900 group-hover:text-white",
              index > 2
                ? "before:absolute before:left-[5%] before:bottom-1/4 before:w-[90%] before:h-[1px] before:bg-disabled-text-color"
                : ""
            )}
          >
            {name}
          </div>
        </button>
      )}
    </>
  )
}
